/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable jsx-a11y/alt-text */
import { desArrow, infoIcn, imsLoader } from '../../assets'
import { useState } from 'react';
import NotebookListPopUp from '../PopUp/NotebookListPopUp'
import "./GenAISummary.css"

const formattedStringArr = (array, fn) => {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        var mapping = fn(array[i]);
        result = result.concat(mapping);
    }
    return result;
}
const divider = () => {
    return (
        <div className="document-descriptor-divider"></div>
    )
}
const textFormatter = (data) => {

    const replacedString = data.replaceAll("%%##%%##", '%%##').replaceAll("%%##", '\n');
    //console.log(newString)
    let updatedText = formattedStringArr(replacedString.split('\n'), function (part) {
        return [part, <div>{divider()}</div>];
    });
    updatedText.pop()
    return (
        <div>
            {updatedText}
        </div>
    )
}
export default function (props) {

    const [isOpen, setOpenDescriptor] = useState(false);
    const [showNotebookList, setShowNotebookList] = useState(false);
    const [summarizeText, setSummarizeText] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    const { summaryText, sourceItem, customWidth } = props
    const handleCloseNotebookList = () => {
        setShowNotebookList(false);
    }
    const handleOpenDescriptor = async () => {
        setOpenDescriptor(!isOpen);
        if (!isOpen && !summarizeText) {

            setIsProcessing(true);
            const { nlpSummary } = sourceItem
            setSummarizeText(nlpSummary.trim())
            setIsProcessing(false);
            // let url = 'https://awsaidnval000f.jnj.com:5059/nlp/api/summarize_api2'
            // let config = {
            //     method: 'POST',
            //     url: url,
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     data: {
            //         "orignalText": summaryText
            //     }
            // }
            // await axios(config).then((response) => {
            //     setSummarizeText(response.data.summarizeText)
            // }).catch((error) => {
            //     console.log(error)
            // }).finally(() => {
            //     setIsProcessing(false);
            // });
        }

    }
    return (
        <div className="gen-ai-key-summary">
            <div className="gen-ai-key-summary__badge">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <title>AI generated summary of the document.</title>
                    <g clip-path="url(#clip0_1446_8959)">
                        <path d="M8.00016 10.6666V7.99992M8.00016 5.33325H8.00683M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1446_8959">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <span className="gen-ai-key-summary__badge-label">Summary</span>
                <svg style={isOpen ? { transform: "rotate(180deg)", cursor: "pointer" } : { cursor: "pointer" }} onClick={e => handleOpenDescriptor()} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6L8 10L12 6" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            {isOpen && <div className="gen-ai-key-summary__card" role="region">
                <div className="gen-ai-key-summary__list">
                    <div
                        className="gen-ai-key-summary__row"
                        role="row"
                    >
                        {isProcessing ? <div style={{ textAlign: "center", padding: "2%" }}>
                            <img src={imsLoader} alt="Loading Filters" style={{ width: "10%" }} />
                        </div> :
                            <>{textFormatter(summarizeText)}</>}

                    </div>
                    <div
                        className="gen-ai-key-btnNotebook"
                        role="row"
                    >
                        {!isProcessing && <div className="notebook-notbook-btn">
                            <button className="gen-ai-key-summary-btnNotebook" type="button" onClick={(e) => setShowNotebookList(true)}  >Add to Notebook</button>
                        </div>}
                    </div>

                </div>
            </div>}
            {
                showNotebookList &&
                <NotebookListPopUp showModal={showNotebookList} sourceItem={sourceItem} summeryText={summaryText} summarizeText={summarizeText} handleClose={handleCloseNotebookList} width={customWidth} commandType='Summarize' />
            }
        </div>
        // <div className="document-descriptor-wrapper">
        //     <div className="document-descriptor-header-wrapper" onClick={e => handleOpenDescriptor()}>
        //         <img src={desArrow} className={isOpen ? "document-descriptor-img-rotate" : "document-descriptor-img"} onClick={e => handleOpenDescriptor()} />
        //         <span> Summary</span>
        //         <img src={infoIcn} className="keyTakeaways-info-icn" title="AI generated summary of the document." />
        //     </div>
        //     {isOpen && <>
        //          <div className="document-descriptor-text-wrapper">
        //             {isProcessing ? <div style={{ textAlign: "center", padding: "2%" }}>
        //                 <img src={imsLoader} alt="Loading Filters" style={{ width: "10%" }} />
        //             </div> :
        //                 <>{textFormatter(summarizeText)}</>}
        //             {!isProcessing && <div className="notebook-notbook-btn">
        //                 <button className="btnNotebook" type="button" onClick={(e) => setShowNotebookList(true)}  >Add to Notebook</button>
        //             </div>}
        //         </div>
        //     </>
        //     }
        //     {
        //         showNotebookList &&
        //         <NotebookListPopUp showModal={showNotebookList} sourceItem={sourceItem} summeryText={summaryText} summarizeText={summarizeText} handleClose={handleCloseNotebookList} width={customWidth}  commandType='Summarize'/>
        //     }
        // </div >
    )
}